<template>
  <div>
    <InfoDialogBase
      v-model="inputedValue"
      :width="width"
      :title="title"
      :pageData="pageData"
      :recItems="recItems"
      :isHistoryType="true"
      :isEdit="false"
      @updateRemarks="updateRemarks"
    >
      <template v-slot:[pageData[1].buttonAreaName]>
        <NormalButton
          v-show="authority.isAdmin"
          :text="`${pageType.ja}` + $t('user.user_cancel')"
          height="32px"
          color="white"
          textColor="thinText--text"
          class="pa-2 mx-1"
          btnClass="px-3"
          :outlined="true"
          @click="cancel"
        />
        <NormalButton
          v-if="!authority.isOutsideStaff"
          :text="`${pageType.ja}` + $t('common.input_fix')"
          height="32px"
          color="white"
          textColor="thinText--text"
          class="pa-2 mx-1"
          btnClass="px-3"
          :outlined="true"
          @click="edit"
        />
      </template>
      <template v-slot:[pageData[3].name]>
        <slot name="shipHistoryList" v-bind:item="shipHistoryListInfo" />
      </template>
      <template
        v-slot:[pageData[4].name]="{ item }"
        v-if="!authority.isOutsideStaff"
      >
        <PaymentTable
          :item="item"
          :unitName="unitName"
          paymentType="sale"
          :isOperation="false"
        />
      </template>
      <template v-slot:[pageData[5].name] v-if="!authority.isOutsideStaff">
        <slot name="refundHistoryList" v-bind:item="refundHistoryData" />
      </template>
      <template v-slot:[pageData[6].name]>
        <slot name="changeHistoryList" v-bind:item="changeHistoryListInfo" />
      </template>
    </InfoDialogBase>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import { productMovesUtil, saleUtil } from '@/util'

import InfoDialogBase from './SalesInfoDialogBase'

import headers from '@/views/sales/History/headers'
import headersShip from '@/views/sales/Ship/headers'
import headersRefund from '@/views/sales/RefundHistory/headers.js'

import NormalButton from '@/components/items/Buttons/NormalButton'
import PaymentTable from '@/components/items/Tables/PaymentTable'

export default {
  components: {
    InfoDialogBase,
    NormalButton,
    PaymentTable
  },
  props: {
    value: { default: false },
    width: { default: '540px' },
    title: { default: '' },
    recItems: {
      type: Object,
      require: true,
      default: () => ({})
    }
  },
  data: () => ({
    pageData: [{}, {}, {}, {}, {}, {}, {}],

    pageType: {
      en: 'sale',
      ja: '注文'
    },

    shipHistoryListInfo: {
      historyList: [],
      headers: [
        {
          text: 'ship.ship_ship-date',
          value: 'shipDate',
          width: '100px'
        },
        {
          text: 'ship.ship_ship-storage',
          value: 'storage.name',
          width: '90px'
        },
        {
          text: 'ship.ship_ship-user',
          value: 'userId',
          width: '90px'
        },
        {
          text: 'payment.payment_operation'
        }
      ],
      tableKey: headersShip.tableKey,
      productListHeaders: headersShip.productListHeaders
    },

    refundHistoryData: {
      historyList: [],
      summary: {},
      headers: [],
      tableKey: ''
    },
    changeHistoryListInfo: {
      historyList: [],
      headers: [
        {
          text: 'common.common_fix-date',
          value: 'loadingDate',
          width: '100px'
        },
        {
          text: 'common.common_fix-user',
          value: 'loadingName',
          width: '80px'
        }
      ],
      tableKey: 'changeId',
      productListHeaders: headers.productListHeaders
    },

    dispCnt: 0,

    unitName: ''
  }),
  methods: {
    ...mapActions('Ship', ['getShipListFromApi']),
    ...mapActions('Refund', ['getRefundListFromApi']),
    ...mapActions('Sale', [
      'getSalePaymentListFromApi',
      'cancelSale',
      'editSaleNote',
      'getSaleDetailFromApi'
    ]),
    ...mapGetters('Refund', ['getRefundListFromState']),
    ...mapActions('Common', ['setIsLoading']),

    getAmount1() {
      // 合計金額
      return '12, 600'
    },
    getAmount1Unit() {
      // 合計金額 単位
      return '元'
    },
    getAmount2() {
      // 未入金金額
      return '5,000'
    },
    getAmount2Unit() {
      // 合計金額 単位
      return '元'
    },
    edit() {
      const nameTmp = this.pageType.en + 's.edit'
      this.$router.push({
        name: nameTmp,
        params: {
          selectItems: this.recItems
        }
      })
    },

    getAmount() {
      // 合計金額
      return !this.authority.isOutsideStaff
        ? saleUtil.calcSaleAmountById(this.recItems.saleId)
        : '*****'
    },
    getPayAmount(paymentList) {
      // 入金済金額
      return !this.authority.isOutsideStaff
        ? paymentList.data.reduce((sum, ele) => {
            return sum + Number(ele.amount)
          }, 0)
        : '*****'
    },

    getTotalAmount(param) {
      const type = 'sale'
      // const productListHeaders = orderHeadersHistory.productListHeaders

      // 発注で履歴に設定された通貨が日本円の場合は各消費税の小計に加える
      let totalAmountAndUnitTaxFree = 0
      if (param.currencyId !== 1) {
        totalAmountAndUnitTaxFree = productMovesUtil.getTotalAmountAndUnit(
          param.saleEditHistoryProduct,
          param.currencyId
        )
      } else {
        totalAmountAndUnitTaxFree = productMovesUtil.getTotalAmountAndUnit(
          param.saleEditHistoryProduct.filter((ele) => ele.exportSubjectFlg),
          param.currencyId
        )
      }

      let totalAmountTax10 = 0
      let totalAmountTax8 = 0
      if (param.currencyId !== 1) {
        totalAmountTax10 = productMovesUtil.getTotalAmount(
          param.saleEditHistoryProduct.filter((ele) => ele.product.taxId === 2)
        )
        totalAmountTax8 = productMovesUtil.getTotalAmount(
          param.saleEditHistoryProduct.filter((ele) => ele.product.taxId === 1)
        )
      } else if (!this.isOrder) {
        totalAmountTax10 = productMovesUtil.getTotalAmount(
          param.saleEditHistoryProduct.filter(
            (ele) => !ele.exportSubjectFlg && ele.product.taxId === 2
          )
        )
        totalAmountTax8 = productMovesUtil.getTotalAmount(
          param.saleEditHistoryProduct.filter(
            (ele) => !ele.exportSubjectFlg && ele.product.taxId === 1
          )
        )
      }
      const totalAmountTax10OnlyTax = param.consumptionTax10
      const totalAmountTax8OnlyTax = param.consumptionTax8

      const totalAmount = saleUtil[
        `calc${type.charAt(0).toUpperCase()}${type.slice(1)}AmountById`
      ](param[`${type}Id`])

      return {
        taxFree: totalAmountAndUnitTaxFree.amount,
        tax10: {
          totalAmount: totalAmountTax10,
          tax: totalAmountTax10OnlyTax
        },
        tax8: {
          totalAmount: totalAmountTax8,
          tax: totalAmountTax8OnlyTax
        },
        discount: this.recItems.discount,
        shipping: this.recItems.comission,
        totalAmount: totalAmount,
        unitName: totalAmountAndUnitTaxFree.unit,
        currencyId: param.currencyId
      }
    },

    async ini() {
      // ship History
      const shipList = await this.getShipListFromApi({
        invalidShipDisplay: 0,
        saleControlNumber: this.recItems.transaction.controlNumber
      })
      const format = shipList.data.map((ele, Index) => {
        ele.panelIndex = Index + 1
        return ele
      })
      this.shipHistoryListInfo.historyList = format

      // payment History
      const paymentList = !this.authority.isOutsideStaff
        ? await this.getSalePaymentListFromApi({
            id: this.recItems.saleId
          })
        : { data: [] }

      // chnage History
      const saleIds = this.recItems.saleId
      const saleDetailList = await this.getSaleDetailFromApi({ saleIds })
      const changeHistoryFormat =
        saleDetailList.data[0].saleEditHistoryList.map((ele, Index) => {
          return {
            changeId: ele.saleEditHistoryId,
            loadingDate: ele.createdAt.split(' ')[0],
            loadingName: ele.user.lastName + ele.user.firstName,
            panelIndex: Index + 1,
            totalList: this.getTotalAmount(ele),
            ...ele
          }
        })
      this.changeHistoryListInfo.historyList = changeHistoryFormat

      const amount = this.getAmount()
      const payAmount = this.getPayAmount(paymentList)
      const notPayAmount = amount - payAmount

      this.pageData = [
        {
          title: 'payment.payment_customer-info',
          name: 'paymentInfo',
          items: [],
          itemKey: ''
        },
        {
          title: 'common.input_sale-details',
          name: 'operationDetail',
          buttonAreaName: 'operationDetailbuttonArea',
          headers: headers.productListHeaders,
          items: [],
          footers: [],
          itemKey: this.recItems.saleId
        },
        {
          title: 'sale.sale_note',
          name: 'test1',
          items: [],
          itemKey: ''
        },
        {
          title: 'common.common_ship-history',
          name: 'shipHistory',
          items: [],
          itemKey: ''
        },
        {
          title: 'payment.payment_sale-payment-history',
          name: 'paymentHistory',
          buttonName: 'payment.payment_sale-payment-cancel',
          itemKey: 'salePaymentId',
          headers: [
            {
              text: 'payment.payment_sale-payment-date',
              value: 'date',
              sortable: false,
              width: '12%'
            },
            {
              text: 'payment.payment_sale-payment-price',
              value: 'amount',
              sortable: false,
              width: '12%',
              align: 'end'
            },
            {
              text: 'payment.payment_sale-payment-method',
              value: 'paymentMethodId',
              sortable: false,
              width: '12%'
            },
            {
              text: 'payment.payment_operation',
              value: 'operationId',
              sortable: false
            }
          ],
          items: paymentList.data,
          footers: [
            {
              name: 'payment.payment_already-sale-payment-price',
              data: payAmount
            },
            {
              name: 'payment.payment_total-price-no-colon',
              data: amount
            },
            {
              name: 'payment.payment_unpaid-price',
              data: notPayAmount
            }
          ]
        },
        {
          title: 'sale.sale_refund-history',
          name: 'test4',
          items: [],
          itemKey: ''
        },
        {
          title: 'common.common_fix-history',
          name: 'changeHistory',
          items: [],
          itemKey: ''
        }
      ]

      // 返金履歴
      const refundHistoryList = !this.authority.isOutsideStaff
        ? await this.getRefundListFromApi({
            invalidRefundDisplay: 0,
            saleControlNumber: this.recItems.transaction.controlNumber
          })
        : { data: [] }
      const isNoData = !Object.keys(refundHistoryList.data).length
      this.refundHistoryData = {
        historyList: isNoData
          ? []
          : refundHistoryList.data
              .sort((a, b) => {
                const keyName = 'refundId'
                if (a[keyName] < b[keyName]) return 1
                if (a[keyName] > b[keyName]) return -1
                return 0
              })
              .map((ele, Index) => {
                ele.panelIndex = Index + 1
                // ele.beforeCompleteFlgTmp = this.getBeforeCompleteFlgTmp(ele)
                return ele
              }),
        headers: headersRefund.headers,
        productListHeaders: headersRefund.productListHeaders,

        tableKey: headersRefund.tableKey
      }
    },
    register() {
      alert('register')
      this.inputedValue = false
    },
    async cancel() {
      if (
        !confirm(`
${this.$t('sale.sale_sale-cancel-confirm')}

${this.$t('order.order_irreversible-confirm')}`)
      )
        return
      this.setIsLoading(true)
      const isSucceed = await this.cancelSale({ id: this.recItems.saleId })
      if (isSucceed) {
        alert(this.$t('common.common_canceled-alert'))
        this.inputedValue.dialog = false
        this.$emit('complete')
      }
      this.setIsLoading(false)
    },
    async updateRemarks(...args) {
      const [remarks, type] = args
      let hasConfirm = false
      const params = { id: this.recItems.saleId }
      if (type === 'private') {
        hasConfirm = confirm(`${this.$t(
          'common.common_confirm-to-save-remarks'
        )}
${this.$t('sale.sale_only-open-to-internal-members')}`)
        params.note = remarks
      } else if (type === 'client') {
        hasConfirm = confirm(`${this.$t(
          'common.common_confirm-to-save-remarks'
        )}
${this.$t('sale.sale_public-information-stated')}`)
        params.saleNote = remarks
      }

      if (!hasConfirm) return
      const isSuccess = await this.editSaleNote(params)

      if (!isSuccess) return
      alert(this.$t('common.common_saved-alert'))
      this.ini()
    }
  },
  computed: {
    ...mapGetters('User', ['authority']),
    inputedValue: {
      get() {
        return this.value
      },
      set(newValue) {
        this.$emit('input', newValue)
      }
    }
  },
  watch: {
    'inputedValue.dialog': async function (val) {
      if (!val) return
      // TODO: なぜか初期表示で返金履歴のRowInfoが認識されない
      // 一旦初期表示時は開けて閉じるという動作を行う
      this.dispCnt += 1
      if (this.dispCnt == 1) this.inputedValue.dialog = false
      await this.ini()
      if (this.dispCnt == 1) this.inputedValue.dialog = true
    }
  }
}
</script>
<style lang="scss" scoped></style>
